import * as server from '../entries/pages/polityka-prywatnosci/_page.server.ts.js';

export const index = 12;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/polityka-prywatnosci/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/polityka-prywatnosci/+page.server.ts";
export const imports = ["_app/immutable/nodes/12.feKkmk_q.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/CpR9_xLq.js","_app/immutable/chunks/CW2ixiyS.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/nKiQWsiX.js"];
export const stylesheets = ["_app/immutable/assets/PageHeadingSection.lmfBmTxA.css","_app/immutable/assets/12.DXocD5Vq.css"];
export const fonts = [];
